import { type ReactElement } from 'react';
import styles from './top-bar-mobile.module.scss';
import { UtmbLink } from '@utmb/design-system/utmb-link/UtmbLink';
import { useRouter } from 'next/router';
import { Icon } from '@utmb/design-system/icons/Icon';
import { IconEnum } from '@utmb/types/enum/IconEnum';
import { getColorStyle } from '@utmb/utils/colors';
import { ColorTypesEnum } from '@utmb/types/colors';
import { Link } from '@utmb/design-system/link/link';

export interface TopBarMobileProps {
    openTray: () => void;
    isTrayOpen: boolean;
}

export function TopBarMobile({ openTray, isTrayOpen }: TopBarMobileProps): ReactElement {
    const { locale, defaultLocale } = useRouter();
    return (
        <div className={styles.topBarMobile}>
            <div className={styles.wrapMenuButton}>
                <button className={styles.menuButton + ' ' + (isTrayOpen ? styles.close : styles.open) + ' burgerMenuButton'} onClick={openTray}>
                    <Icon clss={styles.openIcon} variant={IconEnum.BURGER} color={getColorStyle(ColorTypesEnum.WHITE)} height={30} width={30} />
                    <Icon clss={styles.closeIcon} variant={IconEnum.CLOSE} color={getColorStyle(ColorTypesEnum.WHITE)} height={30} width={30} />
                </button>
            </div>
            <UtmbLink isWS={true} locale={locale} defaultLocale={defaultLocale} registered={false} theme="light" />
            <Link className={styles.accountButton} href={'/my-utmb/my-dashboard'} target="_self">
                <Icon clss={styles.accountIcon} variant={IconEnum.USER} color={getColorStyle(ColorTypesEnum.WHITE)} />
            </Link>
        </div>
    );
}
